import type { ReadonlySignal } from '@preact/signals-core'
import { computed, effect, signal } from '@preact/signals-core'

export type State<T> = ReadonlySignal<T>

export type UpdateState<T> = (newState: (oldState: T) => T) => void

export type OnUpdateState<T> = (listener: (state: T) => void) => () => void

export function createState<T>(defaultValue: T) {
	const state = signal(defaultValue)
	const stateReadonly = computed(() => state.value)

	const updateState: UpdateState<T> = newState =>
		(state.value = newState(state.value))

	const onUpdateState: OnUpdateState<T> = listener =>
		effect(() => {
			listener(state.value)
		})

	return {
		updateState,
		onUpdateState,
		state: stateReadonly
	}
}
